import React, { FC, useState } from 'react';
import Menu from '../Menu';
import TextField, { TextFieldValueType } from '../TextField';
import { parseLocaleNumber } from 'src/utils/formatNumber';
import { styled } from '@mui/system';
import { FilterOperatorType } from 'src/types/table';

const TableNumberFilter = styled('div')({
    width: '100%',
    display: 'block',

    '& .MuiInputBase-root': {
        width: '100%',
        paddingLeft: '0px',
    },

    '& .number-filter-menu': {
        borderRight: '1px solid silver'
    }
});

const operatorOptions: { label: string; value: FilterOperatorType }[] = [
    { label: '=', value: 'eq' },
    { label: '>', value: 'gt' },
    { label: '<', value: 'lt' },
    { label: '≥', value: 'gte' },
    { label: '≤', value: 'lte' },
    { label: '...', value: 'like' }
];

type NumberFilterPropsType = {
    value: any;
    operator: FilterOperatorType;
    onChange: (value: TextFieldValueType, operator: FilterOperatorType) => void;
    name?: string;
};

const NumberFilter: FC<NumberFilterPropsType> = (props) => {
    const [currentOperator, setCurrentOperator] = useState<FilterOperatorType>(props.operator);
    const selectOperator = operatorOptions.find((operator) => operator.value === currentOperator);
    const handleChangeValue = (value: TextFieldValueType) => {
        if (value === '' || value === undefined) {
            props.onChange(undefined, currentOperator);
            return;
        }
        const parsed = parseLocaleNumber(value);
        props.onChange(Number.isNaN(parsed) ? value : String(parsed), currentOperator);
    };

    const handleChangeOperator = (operator: FilterOperatorType) => {
        // Pokud není hodnota definovaná, nevykoná se onChange a nepřepíše se operator
        if (props.value !== undefined && props.value !== '') {
            props.onChange(props.value, operator);
        }
        setCurrentOperator(operator);
    };


    return (
        <TableNumberFilter>
            <TextField
                value={props.value}
                fullWidth
                onChange={handleChangeValue}
                type="numberLocale"
                name={props.name}
                startAdornment={
                    <Menu
                        variant="menu"
                        className="number-filter-menu"
                        itemClassName="table-filter-menu-item"
                        inline
                        icon={<div>{selectOperator?.label}</div>}
                        items={operatorOptions.map((operator) => (
                            <div key={operator.value} onClick={() => handleChangeOperator(operator.value)}>
                                {operator.label}
                            </div>
                        ))}
                    />
                }
                clearValueUndefined
            />
        </TableNumberFilter>
    );
};

export default NumberFilter;
